import { useState, useCallback } from 'react';
import { j209Api } from '../../../services/j209Api';

export function useJ209Navigation(onNavigate: (id: string) => Promise<void>) {
  const [allIds, setAllIds] = useState<string[]>([]);
  const [currentIdx, setCurrentIdx] = useState(-1);

  const loadList = useCallback(async (): Promise<string[]> => {
    const res = await j209Api.list(1, 10000);
    const ids = (res.data || []).map(r => r.fj180_01).filter(Boolean);
    setAllIds(ids);
    return ids;
  }, []);

  const navTo = useCallback(async (idx: number, isEditing: boolean) => {
    if (idx < 0 || idx >= allIds.length || isEditing) return;
    setCurrentIdx(idx);
    await onNavigate(allIds[idx]);
  }, [allIds, onNavigate]);

  return {
    allIds, currentIdx,
    setAllIds, setCurrentIdx,
    loadList, navTo,
  };
}
